<template>
  <div>
    <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="16">
        <div class="title">FIBO China 2022</div>
        </Col>
        <Col span="8" class="f-tar">
        <Button shape="circle" @click="$router.push(`/ex-register/register`)">中文</Button>
        <Button shape="circle" style="margin-left:10px;border-color:#00a0e9;color:#00a0e9;">English</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">Submit space application</Button>
      </div>

      <div class="tip-info">
        <p>Remarks：</p>
        <p>Please kindly note that this is an application form not a contract. There is a chance that you may not be
          allotted the size of stand which you desire.</p>
      </div>
    </div>
  </div>
</template>
’
<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerAddr from "./components/register-addr.vue";
import common from "@/utils/common";
import axios from "axios";
import { MD5 } from 'crypto-js';
import config from '@assets/config.json';
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  props: {},
  data() {
    return {
      loading: false,
      arr: [{ id: 1, path: 'https://api.chinadentalshow.com:8000/uploaded/file/202208/1e7dbd8bf75247fcba874d82301c8544.png' }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    // 获取token
    async token(opt, res) {
      try {
        const params = new URLSearchParams();
        params.append('client_id', 'MYDev-vokDwKQxhN5NHpX8DhWwQmldAK9Yb9');
        params.append('client_secret', 'crOmK3BV8pzjkYNgW7a5ryMnOYpCOM2uO9jh');
        params.append('grant_type', 'client_credentials');
        params.append('scope', 'open_api');

        const response = await axios.post('https://api-ecrm.reed-sinopharm.com/connect/token', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        });
        if (response.data.access_token) {
          this.tokens = response.data.access_token;
          this.myOtherCreate(opt, res)
        }
      } catch (error) {
        console.error('Error:', error);
      }

    },
    // 提交到慕渊云
    async myOtherCreate(opt, res) {

      const xAdprvClientId = 'MYDev-vokDwKQxhN5NHpX8DhWwQmldAK9Yb9'
      const xAdprvClientSecret = '36R8J/zNyWvAHxlnEQhp6ydd1xzVu98ESvdG2pjg4A0='
      const noncestr = common.getRandomString(6)
      const timer = common.getUTCTimestampInSeconds()

      const sign = `x-adprv-client-id=${xAdprvClientId}\\\\x-adprv-client-secret=${xAdprvClientSecret}\\\\x-adprv-noncestr=${noncestr}\\\\x-adprv-timestamp=${timer}`
      const signMd5 = MD5(sign).toString();
      const address = {
        country: opt.newCompany.country,
        province: opt.newCompany.province,
        city: opt.newCompany.city,
        county: '',
        details: opt.newCompany.address,
        postcode: opt.newCompany.postcode
      }
      const contacts = [{
        "kind": '展会联系人',
        "name": opt.newCompany.linkMan,
        "jobTitle": opt.newCompany.linkTitle,
        "phoneNumber": opt.newCompany.linkMob,
        "email": opt.newCompany.linkEmail,
        "tel": {
          countryCode: res.tel.tels.countryCode || '',
          areaCode: res.tel.tels.areaCode || '',
          code: res.tel.tels.code || '',
          subcode: ''
        }
      }]
      const booths = []
      opt.lists.forEach((value, index) => {
        if (index == 0) {
          booths.push({
            "exhibitionId": "3dcec582-1c63-adc4-5380-3a16545b0c5a",
            "kind": value.areaType == 'Raw Space' ? '特装' : '标展',
            "name": value.areaType,
            "num": value.showArea,
            "hall": ''
          })
        }

      })
      const response = await axios
        .post(
          `${config.apiMy.reqApi}/api/v1/intention/CMEFOtherCreate`,
          {
            "name": opt.newCompany.companyName,
            "nameEn": opt.newCompany.companyNameEn,
            "shortName": opt.newCompany.companyNameShort,
            "unicode": opt.newCompany.unifiedCode,
            "shortNameEn": '',
            "address": address,
            "attachmentBusinessLicenseImgUrl": opt.newCompany.imgBusinessLicense ? JSON.parse(opt.newCompany.imgBusinessLicense).url : '',
            "addressEn": "",
            "website": opt.newCompany.website,
            "fax": opt.newCompany.linkFax,
            "invoiceDto": {
              "lookUp": opt.newCompany.invoiceTitle,
              "taxNumber": opt.newCompany.invoiceCode,
              "address": opt.newCompany.invoiceAddress,
              "bank": opt.newCompany.invoiceBank,
              "bankAccount": opt.newCompany.invoiceBankAccount,
              "tel": opt.newCompany.invoiceTelephone,
            },
            "invoiceRemark": '',
            "attachmentLogoUrl": '',
            "contacts": contacts,
            "booths": booths,
            "specialFileds": {
              "isNeedActivity": opt.lists[0].isNeedActivity   //   我公司是否需要在现场做广告宣传、参加会议活动
            },
            "projectId": "b195a5f4-6d84-dcf9-28a3-3a16545b0c46",
            "exhibitionId": "3dcec582-1c63-adc4-5380-3a16545b0c5a"
          },
          {
            headers: {
              'x-exhibition-id': '3dcec582-1c63-adc4-5380-3a16545b0c5a',
              'x-project-id': 'b195a5f4-6d84-dcf9-28a3-3a16545b0c46',
              'content-type': 'application/json',
              'x-adprv-noncestr': noncestr,
              'x-adprv-timestamp': timer,
              'x-adprv-sign': signMd5,
              'Authorization': 'Bearer ' + this.tokens
            }
          }
        )
    },
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerAddr', res2);
      let opt = {
        newCompany: { ...res.form },
        lists: [{
          exhibitionId: '12395618-C8B3-45C1-8216-D7A87407B884',
          ...res2.ApplyCompanyOrder
        }],
        reportType: 'en'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.nameEn;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      // this.token(opt, res)
      let bool = await this.getApplyCompanyRoastCreate(opt);
      this.loading = false;
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyNameEn) + '&exname=' + encodeURI(exname);
        this.$router.push(`/ex-register-en/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "error,try again";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$router.push(`/ex-register-en/register-mobile`);
    }
  },
  mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;

  .top {
    padding: 29px 0 40px;
  }

  .title {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
}

.submit-btn {
  margin-top: 50px;
  text-align: center;

  button {
    padding: 0 46px;
    height: 48px;
    background-color: #00a0e9;
    font-size: 16px;
    border-color: #00a0e9;
    margin-bottom: 80px;
  }
}

.tip-info {
  width: 1200px;
  margin: 0 auto 116px;

  p {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
  }
}
</style>
